import type { UsuarioResumido } from './tipos';

/**
 * Responsáveis pela UBS de origem — quem decide sobre as solicitações dela.
 *
 * Espelho de `backend/src/common/escopo/regulador-responsavel.ts`. Uma unidade
 * pode ter vários; qualquer um deles decide. A checagem aqui só evita oferecer
 * botões que o backend recusaria.
 */
interface UbsComResponsaveis {
  reguladores: UsuarioResumido[];
}

export function ehResponsavelDaUbs(ubs: UbsComResponsaveis, usuarioId: string): boolean {
  return ubs.reguladores.some((regulador) => regulador.id === usuarioId);
}

/** "Ana", "Ana e Carlos", "Ana, Bia e Carlos". */
export function nomesDosResponsaveis(ubs: UbsComResponsaveis): string {
  return new Intl.ListFormat('pt-BR', { style: 'long', type: 'conjunction' }).format(
    ubs.reguladores.map((regulador) => regulador.nome),
  );
}
